import { render, staticRenderFns } from "./dayCareDetail.vue?vue&type=template&id=47444e6c&scoped=true&"
import script from "./dayCareDetail.vue?vue&type=script&lang=js&"
export * from "./dayCareDetail.vue?vue&type=script&lang=js&"
import style0 from "./dayCareDetail.vue?vue&type=style&index=0&id=47444e6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47444e6c",
  null
  
)

export default component.exports